import { Box, Typography } from '@mui/material'
import { Icon } from '@iconify/react/dist/iconify.js'
import { useNavigate, useLocation } from 'react-router-dom'

const SelectPathCard = ({ item }) => {
    const { heading, description, icon, iconColor, bgColor, path } = item
    const navigate = useNavigate()
    const location = useLocation()

    return (
        <Box sx={{ border: "1px solid #898989", p: "1rem", borderRadius: "1rem", display: "flex", my: 2, gap: "1rem" ,cursor:"pointer"}}
            onClick={() => { navigate(path, { state: location.state }) }
            }
        >
            <Box
                sx={{ bgcolor: bgColor, p: 1, borderRadius: 1 }}
            >
                <Icon icon={icon} color={iconColor} width="30" height="30" />
            </Box>
            <Box>
                <Typography variant='body1' mb={0.5}>{heading}</Typography>
                <Typography variant="body2">{description}</Typography>

            </Box>
        </Box>
    )
}

export default SelectPathCard
